import { inject, Injectable } from '@angular/core';
import { Order } from '../../../models/order';
import { first, firstValueFrom, tap } from 'rxjs';
import { ProductionManagementOrderExportService } from './production-management-order-export.service';
import { printDocument } from '../../../utils/print-document';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ProductionManagementCreateZendrShipmentModalComponent } from '../components/production-management-create-zendr-shipment-modal/production-management-create-zendr-shipment-modal.component';
import { FeatureActivatedGuardWrapper } from '../../../guards/feature-activated/feature-activated.guard';

@Injectable({
  providedIn: 'root'
})
export class ProductionManagementModalService {
  public printShippingModalEnabled = false;

  protected orderExportService = inject(ProductionManagementOrderExportService);
  protected ngbModal = inject(NgbModal);
  protected backendFeatureGuard = inject(FeatureActivatedGuardWrapper);

  constructor() {
    this.backendFeatureGuard.isActivated('zendr', '1.0.0', true).pipe(first()).subscribe(activated => {
      this.printShippingModalEnabled = activated;
    });
  }

  public openCreateShipmentModal(order: Order, modalOptions?: NgbModalOptions): Promise<any> {
    const options: NgbModalOptions = {
      backdrop: 'static',
      keyboard: true,
      centered: true,
      size: 'lg',
      ...modalOptions
    };
    const ref = this.ngbModal.open(ProductionManagementCreateZendrShipmentModalComponent, options);
    (ref.componentInstance as ProductionManagementCreateZendrShipmentModalComponent).order = order;
    return ref.result;
  }

  public openCreatePlocksedelModal(order: Order): Promise<any> {
    return firstValueFrom(
      this.orderExportService.exportOrders([order], 'PICKING_LIST').pipe(
        first(),
        tap(data => printDocument(data.body, 'picking-list.pdf'))
      )
    );
  }

  public openCreateFoljesedelModal(order: Order): Promise<any> {
    return firstValueFrom(
      this.orderExportService.exportOrders([order], 'DELIVERY_NOTE_PROFORMA_COMBINED').pipe(
        first(),
        tap(data => printDocument(data.body, 'deliverynote_proforma.pdf'))
      )
    );
  }
}
